$(document).ready(function () {
  // Target the parent element to observe for changes
  const targetNode = document.body;

  // Define the MutationObserver callback
  const observerCallback = function (mutationsList, observer) {
    for (const mutation of mutationsList) {
      if (mutation.type === "childList") {
        // Check if the target element is added to the DOM
        if ($(".loop-widget-purchase-option").length > 0) {
          // Attach click event listener to the target element
          $(".loop-widget-purchase-option").on("click", function () {
            const $finalWidgetPrice = $(this)
              .find(".loop-widget-purchase-option-price")
              .text();
            $(".product-form__submit").text(
              "Add to cart - " + $finalWidgetPrice
            );
          });
          const $finalWidgetPrice1 = $(".loop-widget-purchase-option-selected")
            .find(".loop-widget-purchase-option-price")
            .text();
          $(".loop-widget-purchase-option-selected")
            .find(".loop-widget-purchase-option-price")
            .text();
          $(".product-form__submit").text(
            "Add to cart - " + $finalWidgetPrice1
          );
          const $compareAtPrice = $(
            ".loop-widget-purchase-option-compare-at-price"
          ).text();
          const $regularPrice = $(".loop-widget-purchase-option-price").text();

          const textComparePrice = parseFloat(
            $compareAtPrice.replace(/[^0-9.]/g, "")
          ); // Remove non-numeric characters
          const textRegularPrice = parseFloat(
            $regularPrice.replace(/[^0-9.]/g, "")
          ); // Remove non-numeric characters

          const discountDollar = textComparePrice - textRegularPrice;

          // Update the savings text
          $(".purchase_options-wrap span.savings").text(
            "Save $" + discountDollar.toFixed(2)
          ); // Display 2 decimal places
          // Disconnect the observer after setting up the event
          observer.disconnect();
          break;
        }
      }
    }
  };

  // Create an instance of MutationObserver
  const observer = new MutationObserver(observerCallback);

  // Configure the observer to watch for child nodes being added or removed
  const config = { childList: true, subtree: true };

  // Start observing the target node
  observer.observe(targetNode, config);
});
